var onceOpen=0;
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.openAnimationDelay = null;
    this.renderContentsDelay = null;
    this.openToken = 0;
    this.onOverlayClose = this.close.bind(this);

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', (event) => {
      if (event.target.closest('.drawer__close')) {
        event.preventDefault();
        this.close();
      }
    });

    const overlay = this.querySelector('.CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.onOverlayClose);
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  setBodyScrollLock(locked) {
    document.body.classList.toggle('cart-hidden', locked);
    document.documentElement.classList.toggle('cart-hidden', locked);
    if (typeof $ !== 'undefined') {
      $('body').toggleClass('cart-hidden', locked);
    }
  }

  setOverlayVisible(visible) {
    const overlay = this.querySelector('.CartDrawer-Overlay');
    if (!overlay) return;
    overlay.style.display = visible ? '' : 'none';
    overlay.style.pointerEvents = visible ? '' : 'none';
  }

  syncViewportHeight() {
    if (typeof window.cartHeight === 'function') {
      window.cartHeight();
      return;
    }
    const vv = window.visualViewport;
    const innerH = Math.round(window.innerHeight || 0);
    let vvHeight = Math.round(vv ? vv.height : innerH);
    let top = Math.round(vv ? vv.offsetTop : 0);
    let height = vvHeight;
    let extraBelow = 0;
    const cartOpen = document.documentElement.classList.contains('cart-hidden') || document.body.classList.contains('cart-hidden');
    if (cartOpen && window.matchMedia('(max-width: 855px)').matches && typeof cartCssPx === 'function') {
      const svh = cartCssPx('100svh');
      const dvh = cartCssPx('100dvh');
      const keyboard = svh > 0 && svh - vvHeight > 150;
      if (!keyboard) {
        if (svh > 0 && dvh - svh > 24) {
          const dvhHeight = dvh - top;
          if (dvhHeight > height && dvhHeight - height <= 150) height = dvhHeight;
        }
        const innerGap = innerH - (top + height);
        if (innerGap > 1 && innerGap <= 48) {
          height += innerGap;
          extraBelow = Math.round(innerGap);
        }
      }
    }
    height = Math.max(0, Math.round(height));
    document.documentElement.style.setProperty('--cart-viewport-height', height + 'px');
    document.documentElement.style.setProperty('--cart-viewport-top', top + 'px');
    document.documentElement.style.setProperty('--cart-viewport-bottom-gap', extraBelow + 'px');
  }

  open(triggeredBy) {
    this._closedByUser = false;
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    const openToken = ++this.openToken;
    clearTimeout(this.openAnimationDelay);
    this.setBodyScrollLock(true);
    this.setOverlayVisible(true);
    this.removeAttribute('aria-hidden');
    this.syncViewportHeight();

    this.openAnimationDelay = setTimeout(() => {
      if (openToken !== this.openToken) return;
      this.classList.add('animate', 'active');
      this.syncViewportHeight();
      requestAnimationFrame(() => {
        if (openToken !== this.openToken) return;
        this.syncViewportHeight();
      });
      setTimeout(() => {
        if (openToken !== this.openToken) return;
        this.syncViewportHeight();
      }, 120);
      setTimeout(() => {
        if (openToken !== this.openToken) return;
        this.syncViewportHeight();
      }, 450);
      if (onceOpen != 0) {
        return;
      }
      onceOpen++;
      if (typeof cartNoticeFun === 'function') {
        cartNoticeFun().init();
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    this.openToken++;
    clearTimeout(this.openAnimationDelay);
    clearTimeout(this.renderContentsDelay);
    this.openAnimationDelay = null;
    this.renderContentsDelay = null;

    this._closedByUser = true;
    this.classList.remove('active', 'animate');
    this.setAttribute('aria-hidden', 'true');
    this.setOverlayVisible(false);
    this.setBodyScrollLock(false);
    removeTrapFocus(this.activeElement);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  /**
   * Cart drawer lives in header-group as `cart-model`, so section.id is
   * `sections--…__cart-model`. Many ATC callers still request filename
   * `cart-drawer`. Resolve both so the drawer HTML actually updates.
   */
  resolveSectionHtml(sections, sectionId) {
    if (!sections || typeof sections !== 'object') return null;
    if (sections[sectionId]) return sections[sectionId];
    if (sectionId !== 'cart-icon-bubble' && sections['cart-drawer']) return sections['cart-drawer'];
    if (sectionId === 'cart-icon-bubble') return sections['cart-icon-bubble'] || null;

    const matchKey = Object.keys(sections).find(
      (key) =>
        key === 'cart-drawer' ||
        key.endsWith('__cart-model') ||
        key.endsWith('__cart-drawer')
    );
    return matchKey ? sections[matchKey] : null;
  }

  getSectionsRequestIds() {
    const sectionId = this.getCartDrawerSectionId();
    return [...new Set([sectionId, 'cart-drawer', 'cart-icon-bubble'])].filter(Boolean);
  }

  renderContents(parsedState, options = {}) {
    const shouldOpen = options.open !== false;
    const sectionId = this.getCartDrawerSectionId();
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    const drawerRoot = this.querySelector('#CartDrawer') || this;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? drawerRoot.querySelector(section.selector) || document.querySelector(section.selector)
        : document.getElementById(section.id);
      const sectionHtml = this.resolveSectionHtml(parsedState.sections, section.id);
      if (!sectionElement || !sectionHtml) return;

      const html = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (html) {
        sectionElement.innerHTML = html;
      }
    });

    const openGiftCards = window.__autoGiftOpen || {};
    if (window.__autoGiftCardOpen) {
      openGiftCards.threshold = true;
      openGiftCards.gifts = true;
    }
    drawerRoot.querySelectorAll('[data-auto-gift-card]').forEach((giftCard) => {
      const giftKey = giftCard.getAttribute('data-gift-key') || 'threshold';
      if (!openGiftCards[giftKey]) return;
      giftCard.classList.add('is-open');
      giftCard.setAttribute('aria-expanded', 'true');
    });
    if (typeof window.applyDismissedGiftBar === 'function') window.applyDismissedGiftBar(drawerRoot);

    if (typeof cartOpenValue != 'undefined') {
      if (cartOpenValue.indexOf(parsedState.product_id) != -1) return;
    }

    clearTimeout(this.renderContentsDelay);
    const renderToken = ++this.openToken;

    this.renderContentsDelay = setTimeout(() => {
      if (renderToken !== this.openToken) return;
      if (shouldOpen) {
        this._closedByUser = false;
        this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const node = doc.querySelector(selector);
    return node ? node.innerHTML : '';
  }

  getCartDrawerSectionId() {
    return typeof window.getCartDrawerSectionId === 'function'
      ? window.getCartDrawerSectionId()
      : 'cart-drawer';
  }

  getSectionsToRender() {
    const sectionId = this.getCartDrawerSectionId();
    return [
      {
        id: sectionId,
        selector: '.drawer__header',
      },
      {
        id: sectionId,
        selector: '.recom_list_box1',
      },
      {
        id: sectionId,
        selector: '.recom_list_box2',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: sectionId,
        selector: '.render-data',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getCartDrawerSectionId() {
    return typeof window.getCartDrawerSectionId === 'function'
      ? window.getCartDrawerSectionId()
      : 'cart-drawer';
  }

  getSectionsToRender() {
    const sectionId = this.getCartDrawerSectionId();
    return [
      {
        id: 'CartDrawer',
        section: sectionId,
        selector: '.drawer__header',
      },
      {
        id: 'CartDrawer',
        section: sectionId,
        selector: '.recom_list_box1 .recom_box',
      },
      {
        id: 'CartDrawer',
        section: sectionId,
        selector: '.recom_list_box2 .recom_box',
      },
      {
        id: 'CartDrawer',
        section: sectionId,
        selector: '.gift_list',
      },
      {
        id: 'CartDrawer',
        section: sectionId,
        selector: '.gift_list2',
      },
      {
        id: 'CartDrawer',
        section: sectionId,
        selector: '.render-data',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
